// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentPatientSearchResultModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentPatientSearchResultModel.attributeTypeMap;
    }
}
ExtEnrollmentPatientSearchResultModel.discriminator = undefined;
ExtEnrollmentPatientSearchResultModel.additionalProperties = false;
ExtEnrollmentPatientSearchResultModel.attributeTypeMap = [
    {
        "name": "results",
        "baseName": "results",
        "type": ""
    },
];
//# sourceMappingURL=extEnrollmentPatientSearchResultModel.js.map